export default __webpack_public_path__ + "static/Tek_Sleeping_Pod-65b88475e0e0dfbd2ba5b5f65f0c4a12.png";